import { Slider } from "antd";
import { bool, object } from "prop-types";

import { DynamicFormItem } from "./DynamicFormItem";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

export const DynamicPercentCompleteSlider = ({
  formField,
  formField: {
    property,
    property: { name },
  },
  formDisabled,
}) => {
  const { isDisabled } = useCheckEditableFormField(formField);

  const marks = {
    0: "0%",
    25: "25%",
    50: "50%",
    75: "75%",
    100: "100%",
  };

  return (
    <DynamicFormItem formFieldProperty={property}>
      <Slider
        data-test-id={`dynamic-percent-complete-slider-${name}`}
        marks={marks}
        dots
        step={25}
        disabled={formDisabled || isDisabled}
      />
    </DynamicFormItem>
  );
};

DynamicPercentCompleteSlider.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
